import { render, staticRenderFns } from "./CustomerOutreach.vue?vue&type=template&id=10c27c19&scoped=true&lang=pug&"
import script from "./CustomerOutreach.vue?vue&type=script&lang=js&"
export * from "./CustomerOutreach.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOutreach.vue?vue&type=style&index=0&id=10c27c19&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c27c19",
  null
  
)

export default component.exports